import { Stack, Typography } from '@mui/material';

type Props = {
  nodeCount: number;
  t: (key: string) => string;
};

export function RowCellWorkflowSteps({ nodeCount, t }: Props) {
  return (
    <Stack alignItems="center">
      <Typography variant="subtitle2" sx={{ fontWeight: 800, color: 'text.secondary' }}>
        {nodeCount}
      </Typography>
      <Typography variant="caption" sx={{ color: 'text.disabled', display: 'block', mt: -0.5 }}>
        {t('STEPS')}
      </Typography>
    </Stack>
  );
}
